import generateMobileOtp from "../../apis/generate-mobile-otp/generate-mobile-otp"
import getCreditScoreDetails from "../../apis/get-credit-score-details"
import pincodeMaster from "../../apis/pincode-master"
import singleActionApi from "../../apis/single-action-api/single-action-api";
import getOffers from "../../apis/get-offers/get-offers";
import jocataPreApproved from "../../apis/jocata-pre-approved/jocata-pre-approved";
import configUrlObj from "../../Configuration";
import convertOfferToOpportunity from "../../apis/convert-offers-to-opportunity/convert-offers-to-opportunity"
import commonFunctionObject from "../../common-function";

// import CreditScoreServiceObject from "../../common-function"


const CreditScoreServiceObject = {

}


var base64 = require('base-64');
var personalLoan = "PERSONAL LOAN";
var businessLoan = "BUSINESS LOAN";
var usedCarLoan = "AUTO LOAN";
var twoWheelerLoan = "TWO WHEELER";
var consumerDurabels = "CONSUMER DURABLES";
var homeLoan = "HOME LOAN";
var preapprovedPLStatus;
var preapprovedBlStatus;
var preApprovedOffer = [{
    "title": "Personal Loan",
    "productName": "Personal Loan",
    "imgIcon": "images/icons/icons-16.png",
    "description": "Avail Personal Loan upto 35 Lakhs",
    "knowMore": "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!",
    "offerID": "",
    "serviceChange": false,
    "Eligible_Amount__c" :0
},
{
    "title": "Business Loan",
    "productName": "Business Loan",
    "imgIcon": "images/icons/icons-16.png",
    "description": "Avail Business Loan upto 75 Lakhs",
    "knowMore": "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!",
    "offerID": "",
    "serviceChange": false,
    "Eligible_Amount__c" :0
},

{
    "title": "Two Wheeler Loan",
    "productName": "TWO WHEELER",
    "imgIcon": "images/icons/icons-18.png",
    "description": "Avail Two Wheeler Loan, Finance upto 100% of the cost",
    "knowMore": "https://www.tatacapital.com/vehicle-loan/two-wheeler-loan/apply-now-two-wheeler-loan.html?subsource=FCR",
    "serviceChange": false,
    "Eligible_Amount__c" :0
},
{
    "title": "Used Car Loan",
    "productName": "AUTO LOAN",
    "imgIcon": "images/icons/icons-19.png",
    "description": "Avail Loan upto 50 Lakhs",
    "knowMore": "https://www.tatacapital.com/vehicle-loan/used-car-loan/apply-now-used-car-loan.html?subsource=FCR",
    "serviceChange": false,
    "Eligible_Amount__c" :0
},
{
    "title": "Home Loan",
    "productName": "Home Loan",
    "imgIcon": "images/icons/icons-17.png",
    "description": "Avail Home Loan upto 5 Crores",
    "knowMore": "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!",
    "serviceChange": false,
    "Eligible_Amount__c" :0
},
]



const pincodeMasterService = (requestObj) => {
    return new Promise((resolve, reject) => {
        pincodeMaster(requestObj).then((pincodeMasterResponse) => {
            if (pincodeMasterResponse.header.status.toUpperCase() === "SUCCESS") {
                resolve(pincodeMasterResponse.body.data)
            } else {
                reject()
            }
        }).catch(() => {
            reject("37")
        })
    })
}
CreditScoreServiceObject.pincodeMasterService = pincodeMasterService;


const getCreditScoreDetailsService = (requestObj) => {
    return new Promise((resolve, reject) => {
        getCreditScoreDetails(requestObj).then(response => {
            if (response.header.status.toUpperCase() === "SUCCESS") {
                resolve(response.body)
            } else {
                reject("")
            }
        }).catch((error) => {
            reject("")
        })

    })
}

CreditScoreServiceObject.getCreditScoreDetailsService = getCreditScoreDetailsService;

const generateMobileOtpService = (generateMobileOtpRequest) => {
    return new Promise((resolve, reject) => {
        generateMobileOtp(generateMobileOtpRequest).then((generateMobileOtpResponse) => {
            if (generateMobileOtpResponse.header.status.toUpperCase() == "SUCCESS") {
                if (generateMobileOtpResponse.body.retStatus == "SUCCESS") {
                    resolve(generateMobileOtpResponse.body.otpRefNo)
                } else {
                    reject("L-30")
                }
            } else if (generateMobileOtpResponse.header.status.toUpperCase() === "FAILURE") {
                if (generateMobileOtpResponse.body.message.toLowerCase().includes('exceeded')) {
                    reject("number of attempts exceeded");
                }
            }
            else {
                reject("L-29")
            }
        }).catch((error) => {
            reject("L-28")
        })
    })
}

CreditScoreServiceObject.generateMobileOtpService = generateMobileOtpService


const getAddressLines = (maxSplit, address, sepArr, start, end) => {
    maxSplit = maxSplit ? maxSplit : 1;
    sepArr = sepArr && Array.isArray(sepArr) && sepArr.length > 0 ? sepArr : [","];

    var addressArr = [];
    function getAddressLine(address, start, end) {
        if (!address) return "";
        start = start ? start : 0;
        end = end ? end : 40;

        var addr = address.substring(start, end);
        if (addr.length < address.length) {
            var sep = sepArr[0];
            var maxLen = 0;
            sepArr.forEach(function (innerSep) {
                var lastIndex = addr.lastIndexOf(innerSep);
                if (lastIndex > maxLen) {
                    maxLen = lastIndex;
                    sep = innerSep;
                }
            });
            addr = addr.substring(0, addr.lastIndexOf(sep));
        }

        return addr;
    }

    var cnt = start;
    for (var i = 0; i < maxSplit; i++) {
        var addr = getAddressLine(address, cnt, cnt + end);
        cnt += addr.length;
        addressArr.push(addr);
    }
    return addressArr;
}
CreditScoreServiceObject.getAddressLines = getAddressLines


const singleActionApiService = (singleActionRequest) => {
    return new Promise((resolve, reject) => {
        singleActionApi(singleActionRequest).then((singleActionResponse) => {
            if (singleActionResponse) {
                if (singleActionResponse.header.status === 'SUCCESS') {
                    if (!(singleActionResponse.body.errorString) && singleActionResponse.body.CREDIT_SCORE != '') {
                        resolve(singleActionResponse)
                    } else {
                        if (singleActionResponse.body.errorString) {
                            reject("Dear Customer, mobile number does not match credit score records, please try again with another mobile number.");
                        }
                    }
                } else {
                    reject("Dear Customer, mobile number does not match credit score records, please try again with another mobile number.");
                }
            } else {
                reject("Dear Customer, mobile number does not match credit score records, please try again with another mobile number.")
            }
        }).catch((error) => [
            reject()
        ])
    })
}
CreditScoreServiceObject.singleActionApiService = singleActionApiService;

function getFirstValue(params) {
    var array = params.split("|"), m = "";
    array.forEach(function (el) {
        if (el !== "") {
            el.split(",").forEach(function (e) { if (e !== "" && m === "") { m = e } });
        }
    });
    return m;
}
CreditScoreServiceObject.getFirstValue = getFirstValue

function prePopulateInputFields(data) {
    var userData = data
    // var parsedContractUserData = data?.parsedUserData[data?.currentActiveData.accountNumber];
    var address, pincode, city, regMob, regEmail, state;
    let newObject = {}

    if (userData?.mobiles) {
        regMob = CreditScoreServiceObject.getFirstValue(userData.mobiles);
    } else {
        regMob = "";
    }

    if (userData?.emails) {
        regEmail = CreditScoreServiceObject.getFirstValue(userData.emails);
    } else {
        regEmail = "";
    }

    userData?.contracts?.forEach(function (contract) {
        if (contract?.USER_CREATED_IN_OPEN_DS === "Y") {
            address = contract.ADDRESS_LINE1 + ", " + contract.ADDRESS_LINE2;
            if (contract.ADDRESS_LINE3) {
                address += ", " + contract.ADDRESS_LINE3;
            } else {
                address += " " + contract.ADDRESS_LINE3;
            }
            city = contract.CITY;
            state = contract.STATE;
            pincode = contract.PINCODE;
        }
    });

    var dateOfBirth = CreditScoreServiceObject.getFirstValue(userData?.dobs) ? String(CreditScoreServiceObject.getFirstValue(userData?.dobs)) : "";
    newObject = {
        firstName: userData.FIRST_NAME ? String(userData.FIRST_NAME) : "",
        lastName: userData.LAST_NAME ? String(userData.LAST_NAME) : "",
        dob: dateOfBirth.split(" ")[0],
        panNumber: CreditScoreServiceObject.getFirstValue(userData.pans).toUpperCase() ? String(CreditScoreServiceObject.getFirstValue(userData.pans).toUpperCase()) : "",
        email: regEmail ? String(regEmail) : "",
        mobile: CreditScoreServiceObject.getFirstValue(userData.mobiles) ? String(CreditScoreServiceObject.getFirstValue(userData.mobiles)) : "",
        address: address ? String(address) : "",
        aadharcardnumber: ""
    }
    // 

    return newObject
}

CreditScoreServiceObject.prePopulateInputFields = prePopulateInputFields;


function prePopulateMoneyfyInputFields(data) {
    var userData = data
    // var parsedContractUserData = data?.parsedUserData[data?.currentActiveData.accountNumber];
    var address, pincode, city, regMob, regEmail, state;
    let newObject = {}

    if (userData?.mobileNumber) {
        regMob = CreditScoreServiceObject.getFirstValue(userData.mobileNumber);
    } else {
        regMob = "";
    }

    if (userData?.emailId) {
        regEmail = CreditScoreServiceObject.getFirstValue(userData.emailId);
    } else {
        regEmail = "";
    }


    var dateOfBirth = CreditScoreServiceObject.getFirstValue(userData?.dob) ? String(CreditScoreServiceObject.getFirstValue(userData?.dob)) : "";
    newObject = {
        firstName: userData.firstName ? String(userData.firstName) : "",
        lastName: userData.lastName ? String(userData.lastName) : "",
        dob: dateOfBirth.split(" ")[0],
        panNumber: userData.pan ? String(userData.pan) : "",
        email: regEmail ? String(regEmail) : "",
        mobile: regMob ? String(regMob) : "",
        address: userData.address ? String(userData.address) : "",
        aadharcardnumber: ""
    }
    // 

    return newObject
}

CreditScoreServiceObject.prePopulateMoneyfyInputFields = prePopulateMoneyfyInputFields;

const creditScoreInputValidationCheck = (fieldName, value, creditScoreFormObject, selectedGenderOption) => {
    console.log(selectedGenderOption)
    var mobregx = /^[6-9]{1}[0-9]{9}$/;
    var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var regaadhar = /^[1-9][0-9]{11}$/;
    var regpan = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
    var emojiregex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1F1E0}-\u{1F1FF}\u{1F191}-\u{1F251}\u{1F004}\u{1F0CF}]/u
    var newErrorObject = {}
    var pincoderegex = /^[1-9][0-9]{5}$/
    var DOB = creditScoreFormObject.dob
    var initialDate = new Date().setFullYear(new Date().getFullYear() - 17);
    var dataBaseDate = new Date(DOB).setFullYear(new Date(DOB).getFullYear());
    if (fieldName === "firstName") {
        if (value === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (value.toLowerCase() == (creditScoreFormObject.lastName).toLowerCase()) {
            newErrorObject.firstName = "First & Last Name Not Be Same"
        } else if (emojiregex.test(value)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }
    }
    else if (fieldName === "lastName") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (value === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (value.toLowerCase() == (creditScoreFormObject.firstName).toLowerCase()) {
            newErrorObject.lastName = "First & Last Name Not Be Same"
        } else if (emojiregex.test(value)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }
    }
    else if (fieldName === "dob") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (value === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (emojiregex.test(value)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = ""
        }
    }
    else if (fieldName === "email") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (creditScoreFormObject.dob === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (initialDate < dataBaseDate) {
            newErrorObject.dob = "Invalid date of birth";
        } else if (emojiregex.test(creditScoreFormObject.dob)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = "";
        }

        if (selectedGenderOption === "Select Gender") {
            newErrorObject.gender = "Please Enter Gender"
        } else if (emojiregex.test(selectedGenderOption)) {
            newErrorObject.gender = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.gender = ""
        }

        if (creditScoreFormObject.panNumber === "") {
            newErrorObject.panNumber = "Please Enter PAN Number"
        } else if (!regpan.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Enter Valid PAN Number"
        } else if (emojiregex.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.panNumber = "";
        }

        if (value === "") {
            newErrorObject.email = "Please Enter Email ID"
        } else if (!emailregx.test(value)) {
            newErrorObject.email = "Please Enter Valid Email ID"
        } else if (emojiregex.test(value)) {
            newErrorObject.email = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.email = ""

        }
    }
    else if (fieldName === "panNumber") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (creditScoreFormObject.dob === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (initialDate < dataBaseDate) {
            newErrorObject.dob = "Invalid date of birth";
        } else if (emojiregex.test(creditScoreFormObject.dob)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = "";
        }

        if (selectedGenderOption === "Select Gender") {
            newErrorObject.gender = "Please Enter Gender"
        } else if (emojiregex.test(selectedGenderOption)) {
            newErrorObject.gender = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.gender = ""
        }

        if (value === "") {
            newErrorObject.panNumber = "Please Enter PAN Number"
        } else if (!regpan.test(value)) {
            newErrorObject.panNumber = "Please Enter Valid PAN Number"
        } else if (emojiregex.test(value)) {
            newErrorObject.panNumber = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.panNumber = ""
        }
    }
    else if (fieldName === "aadharcardnumber") {
        if (value === "") {
            newErrorObject.aadharcardnumber = "Please Enter Aadhar Number"
        } else if (!regaadhar.test(value)) {
            newErrorObject.aadharcardnumber = "Please Enter Valid Aadhar Number"
        } else {
            newErrorObject.aadharcardnumber = ""
        }
    }
    else if (fieldName === "mobile") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (creditScoreFormObject.dob === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (initialDate < dataBaseDate) {
            newErrorObject.dob = "Invalid date of birth";
        } else if (emojiregex.test(creditScoreFormObject.dob)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = "";
        }

        if (selectedGenderOption === "Select Gender") {
            newErrorObject.gender = "Please Enter Gender"
        } else if (emojiregex.test(selectedGenderOption)) {
            newErrorObject.gender = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.gender = ""
        }

        if (creditScoreFormObject.panNumber === "") {
            newErrorObject.panNumber = "Please Enter PAN Number"
        } else if (!regpan.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Enter Valid PAN Number"
        } else if (emojiregex.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.panNumber = "";
        }

        if (creditScoreFormObject.email === "") {
            newErrorObject.email = "Please Enter Email ID"
        } else if (!emailregx.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Enter Valid Email ID"
        } else if (emojiregex.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.email = " "
        }

        if (value === "") {
            newErrorObject.mobile = "Please Enter Mobile Number"
        } else if (emojiregex.test(value)) {
            newErrorObject.mobile = "Please Do Not Enter Emoji"
        } else if (!mobregx.test(value)) {
            newErrorObject.mobile = "Enter Valid Mobile Number"
        } else {
            newErrorObject.mobile = ""
        }
    }
    else if (fieldName === "address") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (creditScoreFormObject.dob === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (initialDate < dataBaseDate) {
            newErrorObject.dob = "Invalid date of birth";
        } else if (emojiregex.test(creditScoreFormObject.dob)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = "";
        }

        if (selectedGenderOption === "Select Gender") {
            newErrorObject.gender = "Please Enter Gender"
        } else if (emojiregex.test(selectedGenderOption)) {
            newErrorObject.gender = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.gender = ""
        }

        if (creditScoreFormObject.panNumber === "") {
            newErrorObject.panNumber = "Please Enter PAN Number"
        } else if (!regpan.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Enter Valid PAN Number"
        } else if (emojiregex.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.panNumber = "";
        }

        if (creditScoreFormObject.email === "") {
            newErrorObject.email = "Please Enter Email ID"
        } else if (!emailregx.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Enter Valid Email ID"
        } else if (emojiregex.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.email = " "
        }

        if (creditScoreFormObject.mobile === "") {
            newErrorObject.mobile = "Please Enter Mobile Number"
        } else if (!mobregx.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Enter Valid Mobile Number"
        } else if (emojiregex.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.mobile = ""
        }

        if (value === "") {
            newErrorObject.address = "Please Enter Address"
        } else if (emojiregex.test(value)) {
            newErrorObject.address = "Please Do Not Enter Emoji"
        }
        else {
            newErrorObject.address = ""
        }

    }
    else if (fieldName === "state") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (creditScoreFormObject.dob === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (initialDate < dataBaseDate) {
            newErrorObject.dob = "Invalid date of birth";
        } else if (emojiregex.test(creditScoreFormObject.dob)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = "";
        }

        if (selectedGenderOption === "Select Gender") {
            newErrorObject.gender = "Please Enter Gender"
        } else if (emojiregex.test(selectedGenderOption)) {
            newErrorObject.gender = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.gender = ""
        }

        if (creditScoreFormObject.panNumber === "") {
            newErrorObject.panNumber = "Please Enter PAN Number"
        } else if (!regpan.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Enter Valid PAN Number"
        } else if (emojiregex.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.panNumber = "";
        }

        if (creditScoreFormObject.email === "") {
            newErrorObject.email = "Please Enter Email ID"
        } else if (!emailregx.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Enter Valid Email ID"
        } else if (emojiregex.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.email = " "
        }

        if (creditScoreFormObject.mobile === "") {
            newErrorObject.mobile = "Please Enter Mobile Number"
        } else if (!mobregx.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Enter Valid Mobile Number"
        } else if (emojiregex.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.mobile = ""
        }

        if (creditScoreFormObject.address === "") {
            newErrorObject.address = "Please Enter Address"
        } else if (emojiregex.test(creditScoreFormObject.address)) {
            newErrorObject.address = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.address = "";
        }

        if (value === "") {
            newErrorObject.state = "Please Enter State"
        } else if (emojiregex.test(value)) {
            newErrorObject.state = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.state = ""
        }

    }
    else if (fieldName === "city") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (creditScoreFormObject.dob === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (initialDate < dataBaseDate) {
            newErrorObject.dob = "Invalid date of birth";
        } else if (emojiregex.test(creditScoreFormObject.dob)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = "";
        }

        if (selectedGenderOption === "Select Gender") {
            newErrorObject.gender = "Please Enter Gender"
        } else if (emojiregex.test(selectedGenderOption)) {
            newErrorObject.gender = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.gender = ""
        }

        if (creditScoreFormObject.panNumber === "") {
            newErrorObject.panNumber = "Please Enter PAN Number"
        } else if (!regpan.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Enter Valid PAN Number"
        } else if (emojiregex.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.panNumber = "";
        }

        if (creditScoreFormObject.email === "") {
            newErrorObject.email = "Please Enter Email ID"
        } else if (!emailregx.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Enter Valid Email ID"
        } else if (emojiregex.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.email = " "
        }

        if (creditScoreFormObject.mobile === "") {
            newErrorObject.mobile = "Please Enter Mobile Number"
        } else if (!mobregx.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Enter Valid Mobile Number"
        } else if (emojiregex.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.mobile = ""
        }

        if (creditScoreFormObject.address === "") {
            newErrorObject.address = "Please Enter Address"
        } else if (emojiregex.test(creditScoreFormObject.address)) {
            newErrorObject.address = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.address = "";
        }

        if (creditScoreFormObject.state === "") {
            newErrorObject.state = "Please Enter State"
        } else if (emojiregex.test(creditScoreFormObject.state)) {
            newErrorObject.state = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.state = ""
        }

        if (value === "") {
            newErrorObject.city = "Please Enter City"
        } else if (emojiregex.test(value)) {
            newErrorObject.city = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.city = ""
        }

    }
    else if (fieldName === "pincode") {
        if (creditScoreFormObject.firstName === "") {
            newErrorObject.firstName = "Please Enter First Name"
        } else if (emojiregex.test(creditScoreFormObject.firstName)) {
            newErrorObject.firstName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.firstName = ""
        }

        if (creditScoreFormObject.lastName === "") {
            newErrorObject.lastName = "Please Enter Last Name"
        } else if (emojiregex.test(creditScoreFormObject.lastName)) {
            newErrorObject.lastName = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.lastName = ""
        }

        if (creditScoreFormObject.dob === "") {
            newErrorObject.dob = "Please Enter Date of Birth"
        } else if (initialDate < dataBaseDate) {
            newErrorObject.dob = "Invalid date of birth";
        } else if (emojiregex.test(creditScoreFormObject.dob)) {
            newErrorObject.dob = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.dob = "";
        }

        if (selectedGenderOption === "Select Gender") {
            newErrorObject.gender = "Please Enter Gender"
        } else if (emojiregex.test(selectedGenderOption)) {
            newErrorObject.gender = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.gender = ""
        }

        if (creditScoreFormObject.panNumber === "") {
            newErrorObject.panNumber = "Please Enter PAN Number"
        } else if (!regpan.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Enter Valid PAN Number"
        } else if (emojiregex.test(creditScoreFormObject.panNumber)) {
            newErrorObject.panNumber = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.panNumber = "";
        }

        if (creditScoreFormObject.email === "") {
            newErrorObject.email = "Please Enter Email ID"
        } else if (!emailregx.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Enter Valid Email ID"
        } else if (emojiregex.test(creditScoreFormObject.email)) {
            newErrorObject.email = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.email = " "
        }

        if (creditScoreFormObject.mobile === "") {
            newErrorObject.mobile = "Please Enter Mobile Number"
        } else if (!mobregx.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Enter Valid Mobile Number"
        } else if (emojiregex.test(creditScoreFormObject.mobile)) {
            newErrorObject.mobile = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.mobile = ""
        }

        if (creditScoreFormObject.address === "") {
            newErrorObject.address = "Please Enter Address"
        } else if (emojiregex.test(creditScoreFormObject.address)) {
            newErrorObject.address = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.address = "";
        }

        if (creditScoreFormObject.state === "") {
            newErrorObject.state = "Please Enter State"
        } else if (emojiregex.test(creditScoreFormObject.state)) {
            newErrorObject.state = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.state = ""
        }

        if (creditScoreFormObject.city === "") {
            newErrorObject.city = "Please Enter City"
        } else if (emojiregex.test(creditScoreFormObject.city)) {
            newErrorObject.city = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.city = ""
        }

        if (value === "") {
            newErrorObject.pincode = "Please Enter Pincode"
        } else if (value.length > 6) {
            newErrorObject.pincode = "Please Enter Valid Pincode"
        } else if (emojiregex.test(value)) {
            newErrorObject.pincode = "Please Do Not Enter Emoji"
        } else {
            newErrorObject.pincode = ""
        }

    }

    return newErrorObject

}
CreditScoreServiceObject.creditScoreInputValidationCheck = creditScoreInputValidationCheck

const creditScoreFormValidation = (creditScoreFormObject, selectedGenderOption) => {
    var mobregx = /^[6-9]{1}[0-9]{9}$/;
    var emailregx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var regaadhar = /^[1-9][0-9]{11}$/;
    var regpan = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
    var count = 0
    var newErrorObject = {};
    var DOB = creditScoreFormObject.dob
    var initialDate = new Date().setFullYear(new Date().getFullYear() - 17);
    var dataBaseDate = new Date(DOB).setFullYear(new Date(DOB).getFullYear());
    if (creditScoreFormObject.firstName === "") {
        newErrorObject.firstName = "Please Enter First Name"
    }
    if (creditScoreFormObject.lastName === "") {
        newErrorObject.lastName = "Please Enter Last Name"
    }
    if (creditScoreFormObject.dob === "") {
        newErrorObject.dob = "Please Enter Date of Birth"
    } else if (initialDate < dataBaseDate) {
        newErrorObject.dob = "Invalid date of birth";
    }
    if (creditScoreFormObject.email === "") {
        newErrorObject.email = "Please Enter Email ID"
    } else if (!emailregx.test(creditScoreFormObject.email)) {
        newErrorObject.email = "Please Enter Valid Email ID"
    }
    if (creditScoreFormObject.panNumber === "") {
        newErrorObject.panNumber = "Please Enter PAN Number"
    } else if (!regpan.test(creditScoreFormObject.panNumber)) {
        newErrorObject.panNumber = "Please Enter Valid PAN Number"
    }
    if (creditScoreFormObject.mobile === "") {
        newErrorObject.mobile = "Please Enter Mobile Number"
    } else if (!mobregx.test(creditScoreFormObject.mobile)) {
        newErrorObject.mobile = "Enter Valid Mobile Number"
    }
    if (creditScoreFormObject.address === "") {
        newErrorObject.address = "Please Enter Address"
    }
    if (creditScoreFormObject.state === "") {
        newErrorObject.state = "Please Enter State"
    }
    if (creditScoreFormObject.city === "") {
        newErrorObject.city = "Please Enter City"
    }
    if (creditScoreFormObject.pincode === "") {
        newErrorObject.pincode = "Please Enter Pincode"
    }
    if (selectedGenderOption === "Select Gender") {
        newErrorObject.gender = "Please Enter Gender"
    } else {
        newErrorObject.gender = ""
    }

    var finalErrrorObject = creditScoreCheckBoxValidation(newErrorObject, creditScoreFormObject)

    return finalErrrorObject
}
CreditScoreServiceObject.creditScoreFormValidation = creditScoreFormValidation

const creditScoreCheckBoxValidation = (newErrorObject, creditScoreFormObject) => {
    var checkKeyArray = ["linkCheckbox", "detailsCheckbox", "appointCheckbox"]
    Object.keys(creditScoreFormObject).forEach((keyValue) => {
        if (checkKeyArray.includes(keyValue)) {
            if (keyValue === "linkCheckbox" && creditScoreFormObject[keyValue] === false || keyValue === "detailsCheckbox" && creditScoreFormObject[keyValue] === false || keyValue === "appointCheckbox" && creditScoreFormObject[keyValue] === false) {
                newErrorObject.errorCheckbox = "Please Check all the Terms & Conditions"
                //setFormErrorObject({ ...formErrorObject, errorCheckbox: "Please Check all the Terms & Conditions" })
                //count += 1
            }
        } else {
        }
    })

    return newErrorObject

}




function ccodAddress(ccodCdiContractAddress) {

    var address = "";
    if (ccodCdiContractAddress.ADDRESSLINE1) {
        address += String(ccodCdiContractAddress.ADDRESSLINE1)
    }
    if (ccodCdiContractAddress.ADDRESSLINE2) {
        address += String(ccodCdiContractAddress.ADDRESSLINE2)
    }
    if (ccodCdiContractAddress.ADDRESSLINE3) {
        address += String(ccodCdiContractAddress.ADDRESSLINE3)
    }
    return address ? address : " ";
}

const getOffersService = (requestObj, mobileNumber, authToken) => {
    return new Promise((resolve, reject) => {
        var consumerDurabelsJson = {
            "title": "Consumer Loan",
            "imgIcon": "images/icons/consumerDurable.jpg",
            "description": "Attractive offers to make your purchase quick and easy",
            "applyNowBtn": "https://www.tatacapital.com/business-loan/apply-now-business-loan.html",
            "knowMore": "https://www.tatacapital.com/consumer-durable-loan.html",
            "offerID": "",
            "serviceChange": false
        }
        var callGetOffersApi = getOffers(requestObj)
        callGetOffersApi.then(response => {

            if (response.header.status.toUpperCase() === "SUCCESS") {

                if (Object.keys(response).length !== 0 && response.body.records.length !== 0) {
                    var responseBody = typeof response["body"] === "object" ? response["body"] : {};
                    var getOffersRecord = responseBody.records;
                    let personalLoanFlag = false;
                    let businessLoanFlag = false;
                    getOffersRecord.forEach((data) => {
                        var loanName = data.Product__r.Name;
                        if (loanName.toLowerCase() === "personal loan") {
                            personalLoanFlag = true
                        } else if (loanName.toLowerCase() === "business loan") {
                            businessLoanFlag = true
                        }
                    });
                    if (personalLoanFlag && businessLoanFlag) {
                        let jocataServicePL = jocataService(mobileNumber, "personalLoan", authToken,)

                        jocataServicePL.then((jocataPreApprovedResponse) => {
                            preapprovedPLStatus = jocataPreApprovedResponse
                            let jocataServiceBL = jocataService(mobileNumber, "businessLoan", authToken,)
                            return jocataServiceBL

                        }).then((jocataPreApprovedResponse) => {
                            preapprovedBlStatus = jocataPreApprovedResponse
                            let finalArray = restOfGetOffersFunction(responseBody, consumerDurabelsJson, mobileNumber, preapprovedPLStatus, preapprovedBlStatus)
                            resolve(finalArray)
                        }).catch(function (error) {
                            let finalArray = restOfGetOffersFunction(responseBody, consumerDurabelsJson, mobileNumber, true, true)
                            resolve(finalArray)
                        });
                    }
                    if (personalLoanFlag && !businessLoanFlag) {
                        let jocataServicePL = jocataService(mobileNumber, "personalLoan", authToken)
                        jocataServicePL.then((jocataPreApprovedResponse) => {
                            preapprovedPLStatus = jocataPreApprovedResponse
                            let finalArray = restOfGetOffersFunction(responseBody, consumerDurabelsJson, mobileNumber, preapprovedPLStatus, true)
                            resolve(finalArray)
                        }).catch(function (error) {
                            let finalArray = restOfGetOffersFunction(responseBody, consumerDurabelsJson, mobileNumber, true, true)
                            resolve(finalArray)
                        });
                    }
                    if (businessLoanFlag && !personalLoanFlag) {
                        let jocataServiceBL = jocataService(mobileNumber, "businessLoan", authToken)
                        jocataServiceBL.then((jocataPreApprovedResponse) => {
                            preapprovedBlStatus = jocataPreApprovedResponse
                            let finalArray = restOfGetOffersFunction(responseBody, consumerDurabelsJson, mobileNumber, true, preapprovedBlStatus)
                            resolve(finalArray)
                        }).catch(function (error) {
                            let finalArray = restOfGetOffersFunction(responseBody, consumerDurabelsJson, mobileNumber, true, true)
                            resolve(finalArray)
                        });
                    }
                    if (!personalLoanFlag && !businessLoanFlag) {
                        let finalArray = restOfGetOffersFunction(responseBody, consumerDurabelsJson, mobileNumber, true, true)
                        resolve(finalArray)
                    }
                }
                else {
                    preApprovedOffer = [{
                        "title": "Personal Loan",
                        "productName": "Personal Loan",
                        "imgIcon": "images/icons/icons-16.png",
                        "description": "Avail Personal Loan upto 35 Lakhs",
                        "knowMore": "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!",
                        "offerID": "",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Business Loan",
                        "productName": "Business Loan",
                        "imgIcon": "images/icons/icons-16.png",
                        "description": "Avail Business Loan upto 75 Lakhs",
                        "knowMore": "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!",
                        "offerID": "",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    
                    {
                        "title": "Two Wheeler Loan",
                        "productName": "TWO WHEELER",
                        "imgIcon": "images/icons/icons-18.png",
                        "description": "Avail Two Wheeler Loan, Finance upto 100% of the cost",
                        "knowMore": "https://www.tatacapital.com/vehicle-loan/two-wheeler-loan/apply-now-two-wheeler-loan.html?subsource=FCR",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Used Car Loan",
                        "productName": "AUTO LOAN",
                        "imgIcon": "images/icons/icons-19.png",
                        "description": "Avail Loan upto 50 Lakhs",
                        "knowMore": "https://www.tatacapital.com/vehicle-loan/used-car-loan/apply-now-used-car-loan.html?subsource=FCR",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Home Loan",
                        "productName": "Home Loan",
                        "imgIcon": "images/icons/icons-17.png",
                        "description": "Avail Home Loan upto 5 Crores",
                        "knowMore": "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    ]


                    resolve(preApprovedOffer);
                }
            } else {
                let newErrorObject = {
                    errorCode: "16",
                    preApprovedOffer: [{
                        "title": "Personal Loan",
                        "productName": "Personal Loan",
                        "imgIcon": "images/icons/icons-16.png",
                        "description": "Avail Personal Loan upto 35 Lakhs",
                        "knowMore": "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!",
                        "offerID": "",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Business Loan",
                        "productName": "Business Loan",
                        "imgIcon": "images/icons/icons-16.png",
                        "description": "Avail Business Loan upto 75 Lakhs",
                        "knowMore": "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!",
                        "offerID": "",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
               
                    {
                        "title": "Two Wheeler Loan",
                        "productName": "TWO WHEELER",
                        "imgIcon": "images/icons/icons-18.png",
                        "description": "Avail Two Wheeler Loan, Finance upto 100% of the cost",
                        "knowMore": "https://www.tatacapital.com/vehicle-loan/two-wheeler-loan/apply-now-two-wheeler-loan.html?subsource=FCR",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Used Car Loan",
                        "productName": "AUTO LOAN",
                        "imgIcon": "images/icons/icons-19.png",
                        "description": "Avail Loan upto 50 Lakhs",
                        "knowMore": "https://www.tatacapital.com/vehicle-loan/used-car-loan/apply-now-used-car-loan.html?subsource=FCR",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Home Loan",
                        "productName": "Home Loan",
                        "imgIcon": "images/icons/icons-17.png",
                        "description": "Avail Home Loan upto 5 Crores",
                        "knowMore": "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    ]

                }
                reject(newErrorObject);
            }
        }).catch((error) => {
            reject("16");

                // if (error?.search("Currently we are not able to fetch") > -1) {
                //     reject(error)
                // } else {
                //     reject("16");
                // }
            
        })
    })
}
CreditScoreServiceObject.getOffersService = getOffersService


const restOfGetOffersFunction = (responseBody, consumerDurabelsJson, mobileNumber, preapprovedPLStatus, preapprovedBlStatus) => {
    var filteredArr = responseBody.records.filter(function (record) {
        return record.Product__r.Name.toUpperCase() === personalLoan;
    });


    var filteredArrHl = responseBody.records.filter(function (record) {
        return record.Product__r.Name.toUpperCase() === homeLoan;
    });

    var filteredArrOfTwl = responseBody.records.filter(function (record) {
        return record.Product__r.Name.toUpperCase() === twoWheelerLoan;
    });

    var filteredArrOfBl = responseBody.records.filter(function (record) {
        return record.Product__r.Name.toUpperCase() === businessLoan;
    });

    var filteredArrOfUcl = responseBody.records.filter(function (record) {
        return record.Product__r.Name.toUpperCase() === usedCarLoan;
    });

    var mobileByPassOtp = "mobileNumber=" + mobileNumber + "&otpBypass=" + true;
    if (filteredArr.length !== 0 && !preapprovedPLStatus) {
        preApprovedOffer[0].description = 'Upto ₹ ' + parseFloat(filteredArr[0].Eligible_Amount__c).toLocaleString('en-IN') + ' for ' + filteredArr[0].Tenure_in_Months__c.toString() + ' months.';
        preApprovedOffer[0].serviceChange = false;
        preApprovedOffer[0].jocataRedirection = true;
        preApprovedOffer[0].offerID = filteredArr[0].OfferId__c.toString();
        preApprovedOffer[0].applyNowBtn = "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!";
        // preApprovedOffer[0].applyNowBtn = "https://loanuat.tatacapital.com:8080/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!";
        if (configUrlObj.environment === "PRODUCTION") {
            // preApprovedOffer[0].applyNowBtn = "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=Web#!";
            preApprovedOffer[0].applyNowBtn = "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!";
        } else if (configUrlObj.environment === "DEVELOPMENT") {
            preApprovedOffer[0].applyNowBtn = "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!";
        }
        preApprovedOffer[0].Eligible_Amount__c = filteredArr[0].Eligible_Amount__c;

    }

    if (filteredArrOfTwl.length !== 0) {
        preApprovedOffer[2].title = "Two Wheeler Loan";
        preApprovedOffer[2].productName = "TWO WHEELER";
        preApprovedOffer[2].imgIcon = "images/icons/two-wheeler-1.png";
        preApprovedOffer[2].description = 'Upto ₹ ' + parseFloat(filteredArrOfTwl[0].Eligible_Amount__c).toLocaleString('en-IN') + ' for ' + filteredArrOfTwl[0].Tenure_in_Months__c.toString() + ' months.';
        preApprovedOffer[2].serviceChange = true;
        preApprovedOffer[2].offerID = filteredArrOfTwl[0].OfferId__c.toString();
        preApprovedOffer[2].knowMore = "https://www.tatacapital.com/two-wheeler-loan.html";
        preApprovedOffer[2].Eligible_Amount__c  = filteredArrOfTwl[0].Eligible_Amount__c;
    }

    if (filteredArrOfUcl.length !== 0) {
        preApprovedOffer[3].title = "Used Car Loan";
        preApprovedOffer[3].productName = "AUTO LOAN";
        preApprovedOffer[3].description = 'Upto ₹ ' + parseFloat(filteredArrOfUcl[0].Eligible_Amount__c).toLocaleString('en-IN') + ' for ' + filteredArrOfUcl[0].Tenure_in_Months__c.toString() + ' months.';
        preApprovedOffer[3].serviceChange = true;
        preApprovedOffer[3].offerID = filteredArrOfUcl[0].OfferId__c.toString();
        preApprovedOffer[3].Eligible_Amount__c  = filteredArrOfUcl[0].Eligible_Amount__c;

    }


    if (filteredArrOfBl.length !== 0 && !preapprovedBlStatus) {
        preApprovedOffer[1].description = 'Upto ₹ ' + parseFloat(filteredArrOfBl[0].Eligible_Amount__c).toLocaleString('en-IN') + ' for ' + filteredArrOfBl[0].Tenure_in_Months__c.toString() + ' months.';
        preApprovedOffer[1].serviceChange = false;
        preApprovedOffer[1].productName = "BL";
        preApprovedOffer[1].jocataRedirection = true;
        preApprovedOffer[1].offerID = filteredArrOfBl[0].OfferId__c.toString();
        preApprovedOffer[1].applyNowBtn = "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!";
        // preApprovedOffer[1].applyNowBtn = "https://loanuat.tatacapital.com:8083/online/loans/business-loans?sourceName=FCR#!";
        if (configUrlObj.environment === "PRODUCTION") {
            // preApprovedOffer[3].applyNowBtn = "https://www.tatacapital.com/online/loans/business-loans?sourceName=Web#!"
            preApprovedOffer[1].applyNowBtn = "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!"
        } else if (configUrlObj.environment === "DEVELOPMENT") {
            preApprovedOffer[1].applyNowBtn = "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!"
        }
        preApprovedOffer[1].Eligible_Amount__c  = filteredArrOfBl[0].Eligible_Amount__c;
    }

    // if (filteredArrOfCd.length !== 0) {
    //     console.log('CD OFFERCE : ', filteredArrOfCd[0]);
    //     consumerDurabelsJson.title = "Consumer Loan";
    //     consumerDurabelsJson.productName = "CONSUMER DURABLES";
    //     consumerDurabelsJson.description = 'Upto ₹ ' + parseFloat(filteredArrOfCd[0].Eligible_Amount__c).toLocaleString('en-IN') + ' for 24 months.';
    //     consumerDurabelsJson.serviceChange = true;
    //     consumerDurabelsJson.offerID = filteredArrOfCd[0].OfferId__c.toString();
    //     // preApprovedOffer.splice(2, 0, consumerDurabelsJson);
    //     preApprovedOffer[2] = consumerDurabelsJson;
    // }

    // if (filteredArrHl.length !== 0) {
    //     preApprovedOffer[2].title = "Home Loan";
    //     preApprovedOffer[2].productName = "HL";
    //     preApprovedOffer[2].imgIcon = "images/icons/two-wheeler-1.png";
    //     preApprovedOffer[2].description = 'Upto ₹ ' + parseFloat(filteredArrHl[0].Eligible_Amount__c).toLocaleString('en-IN') + ' for ' + filteredArrHl[0].Tenure_in_Months__c.toString() + ' months.';
    //     preApprovedOffer[2].jocataRedirection = true;
    //     preApprovedOffer[2].offerID = filteredArrHl[0].OfferId__c.toString();
    //     // preApprovedOffer[2].knowMore = "https://www.tatacapital.com/home-loan.html";
    //     preApprovedOffer[2].applyNowBtn = "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!";
    //     if (configUrlObj.environment === "PRODUCTION") {
    //         // preApprovedOffer[0].applyNowBtn = "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=Web#!";
    //         preApprovedOffer[2].applyNowBtn = "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!";
    //     } else if (configUrlObj.environment === "DEVELOPMENT") {
    //         preApprovedOffer[2].applyNowBtn = "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!";
    //     }
    //     preApprovedOffer[2].Eligible_Amount__c  = filteredArrHl[0].Eligible_Amount__c;
    // }
    checkOffersAndStore(responseBody.records);
    // 
    var newPreApprovedOffers = []
    var getDynamicOfferName = [];
    var getDynamicOfferArray = preApprovedOffer.filter((data) => {
        return data.jocataRedirection && data.jocataRedirection === true
    })

    getDynamicOfferArray.forEach((data) => {
        newPreApprovedOffers.push(data)
        getDynamicOfferName.push(data.title)
    })

    preApprovedOffer.forEach((data) => {
        if (!getDynamicOfferName.includes(data.title)) {
            newPreApprovedOffers.push(data)
        } else {

        }
    })
    console.log(newPreApprovedOffers)

    let filternewarr = newPreApprovedOffers.sort(function (a, b) {
        return b.Eligible_Amount__c
            - a.Eligible_Amount__c
            ;
    });
    console.log(filternewarr);

    return filternewarr;
}

const checkOffersAndStore = (offersArr) => {
    var prority = ["PERSONAL LOAN", "CONSUMER DURABLES", "AUTO LOAN", "TWO WHEELER", "HOME LOAN", "BUSINESS LOAN"];
    for (var i = 0; i <= prority.length; i++) {
        if (prority[i] === "PERSONAL LOAN" && preapprovedPLStatus) {
            continue;
        }
        if (prority[i] === "BUSINESS LOAN" && preapprovedBlStatus) {
            continue;
        }
        var filterData = offersArr.filter(function (record) {
            return record.Product__r.Name === prority[i];
        });
        if (filterData.length > 0) {
            //to be continued   
            //dataStore.set('filteredOffers', filterData[0]);
            break;
        }
    }
}

const jocataService = (mobileNumber, productName, authToken) => {
    return new Promise((resolve, reject) => {
        var jocataPlObj = {

            "header": {
                "authToken": authToken,
                "productName": productName
            },
            "body": {
                "mobileNumber": mobileNumber
            }

        };
        commonFunctionObject._setCookie('Authorization', authToken);

        var callJocataPreApprovedApi = jocataPreApproved(jocataPlObj)
        callJocataPreApprovedApi.then(response => {
            if (response.header.status.toUpperCase() === "SUCCESS") {
                if (response.body.status.statusCode === "200") {
                    if (productName === "personalLoan") {
                        var activeStatusCheckForPersonalLoan = response.body.plOnlineJourneyExistingStatus;
                        console.log(activeStatusCheckForPersonalLoan);
                        resolve(activeStatusCheckForPersonalLoan);
                    }
                    if (productName === "businessLoan") {
                        var activeStatusCheckForBusinessLoan = response.body.existingCustomer;
                        resolve(activeStatusCheckForBusinessLoan);
                    }
                } else {
                    let newErrorObject = {
                        errorCode: "Currently we are not able to fetch",
                        preApprovedOffer: [{
                            "title": "Personal Loan",
                            "productName": "Personal Loan",
                            "imgIcon": "images/icons/icons-16.png",
                            "description": "Avail Personal Loan upto 35 Lakhs",
                            "knowMore": "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!",
                            "offerID": "",
                            "serviceChange": false,
                            "Eligible_Amount__c" :0
                        },
                        {
                            "title": "Business Loan",
                            "productName": "Business Loan",
                            "imgIcon": "images/icons/icons-16.png",
                            "description": "Avail Business Loan upto 75 Lakhs",
                            "knowMore": "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!",
                            "offerID": "",
                            "serviceChange": false,
                            "Eligible_Amount__c" :0
                        },
                       
                        {
                            "title": "Two Wheeler Loan",
                            "productName": "TWO WHEELER",
                            "imgIcon": "images/icons/icons-18.png",
                            "description": "Avail Two Wheeler Loan, Finance upto 100% of the cost",
                            "knowMore": "https://www.tatacapital.com/vehicle-loan/two-wheeler-loan/apply-now-two-wheeler-loan.html?subsource=FCR",
                            "serviceChange": false,
                            "Eligible_Amount__c" :0
                        },
                        {
                            "title": "Used Car Loan",
                            "productName": "AUTO LOAN",
                            "imgIcon": "images/icons/icons-19.png",
                            "description": "Avail Loan upto 50 Lakhs",
                            "knowMore": "https://www.tatacapital.com/vehicle-loan/used-car-loan/apply-now-used-car-loan.html?subsource=FCR",
                            "serviceChange": false,
                            "Eligible_Amount__c" :0
                        },
                        {
                            "title": "Home Loan",
                            "productName": "Home Loan",
                            "imgIcon": "images/icons/icons-17.png",
                            "description": "Avail Home Loan upto 5 Crores",
                            "knowMore": "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!",
                            "serviceChange": false,
                            "Eligible_Amount__c" :0
                        },
                        ]

                    }
                    reject(newErrorObject);
                }
            } else {
                let newErrorObject = {
                    errorCode: "Currently we are not able to fetch",
                    preApprovedOffer: [{
                        "title": "Personal Loan",
                        "productName": "Personal Loan",
                        "imgIcon": "images/icons/icons-16.png",
                        "description": "Avail Personal Loan upto 35 Lakhs",
                        "knowMore": "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!",
                        "offerID": "",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Business Loan",
                        "productName": "Business Loan",
                        "imgIcon": "images/icons/icons-16.png",
                        "description": "Avail Business Loan upto 75 Lakhs",
                        "knowMore": "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!",
                        "offerID": "",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    
                    {
                        "title": "Two Wheeler Loan",
                        "productName": "TWO WHEELER",
                        "imgIcon": "images/icons/icons-18.png",
                        "description": "Avail Two Wheeler Loan, Finance upto 100% of the cost",
                        "knowMore": "https://www.tatacapital.com/vehicle-loan/two-wheeler-loan/apply-now-two-wheeler-loan.html?subsource=FCR",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Used Car Loan",
                        "productName": "AUTO LOAN",
                        "imgIcon": "images/icons/icons-19.png",
                        "description": "Avail Loan upto 50 Lakhs",
                        "knowMore": "https://www.tatacapital.com/vehicle-loan/used-car-loan/apply-now-used-car-loan.html?subsource=FCR",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    {
                        "title": "Home Loan",
                        "productName": "Home Loan",
                        "imgIcon": "images/icons/icons-17.png",
                        "description": "Avail Home Loan upto 5 Crores",
                        "knowMore": "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!",
                        "serviceChange": false,
                        "Eligible_Amount__c" :0
                    },
                    ]

                }
                reject(newErrorObject);
            }
            // resolve(response);
            // console.log(response.body.records[0].Product__r.Name);
        }).catch((error) => {
            let newErrorObject = {
                errorCode: "Currently we are not able to fetch",
                preApprovedOffer: [{
                    "title": "Personal Loan",
                    "productName": "Personal Loan",
                    "imgIcon": "images/icons/icons-16.png",
                    "description": "Avail Personal Loan upto 35 Lakhs",
                    "knowMore": "https://www.tatacapital.com/online/loans/personal-loans/apply-now-personal-loan?sourceName=FCR#!",
                    "offerID": "",
                    "serviceChange": false,
                    "Eligible_Amount__c" :0

                },
                {
                    "title": "Business Loan",
                    "productName": "Business Loan",
                    "imgIcon": "images/icons/icons-16.png",
                    "description": "Avail Business Loan upto 75 Lakhs",
                    "knowMore": "https://www.tatacapital.com/online/loans/business-loans/home?sourceName=FCR#!",
                    "offerID": "",
                    "serviceChange": false,
                    "Eligible_Amount__c" :0
                },
                
                {
                    "title": "Two Wheeler Loan",
                    "productName": "TWO WHEELER",
                    "imgIcon": "images/icons/icons-18.png",
                    "description": "Avail Two Wheeler Loan, Finance upto 100% of the cost",
                    "knowMore": "https://www.tatacapital.com/vehicle-loan/two-wheeler-loan/apply-now-two-wheeler-loan.html?subsource=FCR",
                    "serviceChange": false,
                    "Eligible_Amount__c" :0
                },
                {
                    "title": "Used Car Loan",
                    "productName": "AUTO LOAN",
                    "imgIcon": "images/icons/icons-19.png",
                    "description": "Avail Loan upto 50 Lakhs",
                    "knowMore": "https://www.tatacapital.com/vehicle-loan/used-car-loan/apply-now-used-car-loan.html?subsource=FCR",
                    "serviceChange": false,
                    "Eligible_Amount__c" :0
                },
                {
                    "title": "Home Loan",
                    "productName": "Home Loan",
                    "imgIcon": "images/icons/icons-17.png",
                    "description": "Avail Home Loan upto 5 Crores",
                    "knowMore": "https://www.tatacapital.com/online/loans/home-loans/apply-now-home-loan?sourceName=FCR#!",
                    "serviceChange": false,
                    "Eligible_Amount__c" :0
                },
                ]

            }
            reject(newErrorObject);
        });
    })
}


const offerToOpportunityService = (requestJson) => {
    return new Promise((resolve, reject) => {

        convertOfferToOpportunity(requestJson).then(response => {
            if (response) {

                if (response.header.status === "SUCCESS") {
                    if (response.body.status.toUpperCase() === "SUCCESS") {
                        resolve(response);
                    } else {
                        reject("74")
                    }
                } else {
                    reject("20")
                }
            }
            console.log(response)
        }).catch((error) => {
            reject("19");
        });
    })
}
CreditScoreServiceObject.offerToOpportunityService = offerToOpportunityService;

export default CreditScoreServiceObject;